import { request } from "./client";

/** Current usage vs. limits for the signed-in account. `-1` limit = unlimited. */
export interface Entitlements {
  plan: string;
  status: string;
  sites: { used: number; limit: number };
  edits: { used: number; limit: number };
  rebuilds: { used: number; limit: number };
  periodEnd: string | null;
}

export interface PlanOption {
  id: string;
  name: string;
  priceUsd: number;
  siteLimit: number;
  editLimit: number;
  rebuildLimit: number;
}

export interface PlansResponse {
  plans: PlanOption[];
  /** The sentinel a limit uses to mean "unlimited" (`-1`). */
  unlimited: number;
  /** True while the intro trial is live (everyone is on the promo plan). */
  promoActive: boolean;
}

export const billingApi = {
  getEntitlements: () => request<Entitlements>("/api/billing/entitlements"),
  getPlans: () => request<PlansResponse>("/api/billing/plans"),
  // Checkout / portal answer 503 while Stripe is not configured — callers treat
  // that as "billing isn't switched on yet", never an error.
  startCheckout: (planId: string) =>
    request<{ url: string | null }>("/api/billing/checkout", {
      method: "POST",
      body: JSON.stringify({ planId }),
    }),
  openBillingPortal: () =>
    request<{ url: string }>("/api/billing/portal", {
      method: "POST",
      body: JSON.stringify({}),
    }),
};
